import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalStateService } from '@app/core/services/global-state.service';
import { SeoService } from '@app/core/services/seo.service';
import { RouteMatchResult, UrlMatcher } from 'ui/shared/url-matcher';
import { ResolverType } from 'ui/shared/url-matcher/resolver-types.enum';
import { ValidableType, ValidationTypeIdEnum } from 'ui/features/validations';

@Component({
    selector: 'app-transaction-info-screenshot',
    templateUrl: './transaction-info-screenshot.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./transaction-info-screenshot.component.scss']
})
export class TransactionInfoScreenshotComponent {
    private urlMatcher: UrlMatcher = new UrlMatcher();
    private urlResolver: RouteMatchResult;
    public validableType: ValidableType = ValidableType.TRANSACTION;

    public constructor(private router: Router, private globalStateService: GlobalStateService, private seoService: SeoService) {
        this.urlResolver = this.urlMatcher.match(this.router.url);
        this.seoService.addTitle('Comprobantes del pedido | Saldoar');
    }

    public get validationTypeId(): string {
        return ValidationTypeIdEnum.SCREENSHOT;
    }

    public get validableId(): string {
        return this.urlResolver.params.transactionId;
    }

    public get beforepath(): string {
        if (this.urlResolver.type === ResolverType.DASHBOARD_TRANSACTION_SCREENSHOT) {
            return 'users/' + this.globalStateService.userId + '/transactions/' + this.urlResolver.params.transactionId;
        }

        return 't';
    }

    public get beforepathCreate(): string {
        if (this.urlResolver.type === ResolverType.DASHBOARD_TRANSACTION_SCREENSHOT) {
            return 'users/' + this.globalStateService.userId;
        }

        return 't';
    }
}
